<template>
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="16" cy="16" r="16" fill="currentColor" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.9995 20.0028V22.4163C24.0013 22.8693 23.8121 23.3021 23.4783 23.6084C23.1444 23.9147 22.6969 24.066 22.2457 24.0252C19.7702 23.7562 17.3923 22.9103 15.3031 21.5555C13.3594 20.3203 11.7114 18.6724 10.4763 16.7286C9.11669 14.6299 8.2706 12.2405 8.00654 9.75383C7.96589 9.30403 8.11616 8.85785 8.42065 8.52429C8.72514 8.19073 9.1558 8.0005 9.60744 8.00008H12.0209C12.8284 7.99213 13.5168 8.5841 13.6298 9.38378C13.7317 10.1561 13.9206 10.9145 14.1929 11.6444C14.414 12.2323 14.2726 12.8952 13.8309 13.3418L12.8093 14.3635C13.9545 16.3775 15.6221 18.0451 17.6361 19.1903L18.6578 18.1686C19.1044 17.727 19.7673 17.5856 20.3552 17.8066C21.0851 18.079 21.8435 18.2679 22.6158 18.3698C23.4248 18.4839 24.0198 19.1861 23.9995 20.0028Z"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>

<script>
export default {
    name: "CirclePhoneIcon",
};
</script>
